import Vue from 'vue';
import { AwsRum } from 'aws-rum-web';
import production from './production'
import staging from './staging'

export default {
  initialize: () => {
    let params = null
    if (process.env.NODE_ENV === 'staging') params = staging
    else if (process.env.NODE_ENV === 'production') params = production
    else return

    try {
      const awsRum = new AwsRum(
        params.APPLICATION_ID,
        params.APPLICATION_VERSION,
        params.APPLICATION_REGION,
        params.config
      );
      Vue.prototype.$awsRum = awsRum
    } catch (error) {
      // Ignore errors thrown during CloudWatch RUM web client initialization
    }
  }
}
